import { createSelector } from '@ngrx/store';

export const selectAuthState = (state: any) => state.user;

export const currentUser = createSelector(
  selectAuthState,
  auth => (auth && auth.user) || null,
);

export const currentEstablecimientos = createSelector(
  selectAuthState,
  auth => (auth && auth.establecimientos) || null,
);

export const currentEstablecimientoSelected = createSelector(
  selectAuthState,
  auth => (auth && auth.establecimientoSelected) || null,
);

export const isEstablecimientoSelected = createSelector(
  selectAuthState,
  auth => (auth && auth.isEstablecimientoSelected) || null,
);

export const isUserLoaded = createSelector(
  selectAuthState,
  auth => (auth && auth.isUserLoaded) || null,
);
